/**
 * Asynchronously loads the component for CampusIndustryConnect
 */

import { lazyLoad } from "utils/loadable";

export const CampusIndustryConnect = lazyLoad(
  () => import("./index"),
  (module) => module.CampusIndustryConnect
);
